<template>
  <v-container>
    <h2 style="color:gray">Cài đặt quỹ xu</h2>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-student-credit-manager"
          hide-details
          :label="'Cho phép ' + roleName + ' quản lý quỹ xu'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="charge-student-credit"
          hide-details
          :label="'Cho phép ' + roleName + ' nạp xu'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-detail-student-credit"
          hide-details
          :label="'Cho phép ' + roleName + ' xem chi tiết quỹ xu của Học viên'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-detail-student-credit-report"
          hide-details
          :label="'Cho phép ' + roleName + ' xem báo cáo quỹ xu của Học viên'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>

<style scoped></style>
